import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { DashboardDrawer } from '@portal/app-admin'

export const Route = createFileRoute('/_auth/preferences/dashboards/new')({
  component: NewDashboardRoute,
})

function NewDashboardRoute() {
  const navigate = useNavigate()
  return <DashboardDrawer onClose={() => void navigate({ to: '/preferences/dashboards' })} />
}
